var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._b({attrs:{"type":"number","label":_vm.label,"error-messages":_vm.errors || [],"required":_vm.required,"suffix":"%"},model:{value:(_vm.result),callback:function ($$v) {_vm.result=$$v},expression:"result"}},'v-text-field',_vm.customProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }